import { createAction } from "redux-actions";

import {
  GET_SINGLE_CLIENT_REPORT_ENTRIES,
  GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT,
  SET_SINGLE_CLIENT_REPORT_ENTRIES_CURRENT_PAGE,
  SET_SINGLE_CLIENT_REPORT_ENTRIES_FILTERS,
  CLEAR_SINGLE_CLIENT_REPORT_ENTRIES,
  SET_NO_ENTRIES_MESSAGE_SINGLE_CLIENT_REPORT,
} from "../../types";

import createAsyncActions from "../../../../utilities/createAsyncActions";

export const {
  getSingleClientReportEntries,
  getSingleClientReportEntriesPending,
  getSingleClientReportEntriesFulfilled,
  getSingleClientReportEntriesRejected,
} = createAsyncActions(
  GET_SINGLE_CLIENT_REPORT_ENTRIES,
  "getSingleClientReportEntries"
);

export const {
  getSingleClientReportEntriesCount,
  getSingleClientReportEntriesCountPending,
  getSingleClientReportEntriesCountFulfilled,
  getSingleClientReportEntriesCountRejected,
} = createAsyncActions(
  GET_SINGLE_CLIENT_REPORT_ENTRIES_COUNT,
  "getSingleClientReportEntriesCount"
);

export const setSingleClientReportEntriesSearchFilters = createAction(
  SET_SINGLE_CLIENT_REPORT_ENTRIES_FILTERS
);
export const setSingleClientReportEntriesCurrentPage = createAction(
  SET_SINGLE_CLIENT_REPORT_ENTRIES_CURRENT_PAGE
);
export const clearSingleClientReportEntries = createAction(
  CLEAR_SINGLE_CLIENT_REPORT_ENTRIES
);
export const setNoEntriesMessage = createAction(
  SET_NO_ENTRIES_MESSAGE_SINGLE_CLIENT_REPORT
);



// WEBPACK FOOTER //
// ./src/features/reports/actions/single-client/getSingleClientReportEntriesActions.js